import React from "react";
import { Outlet } from "react-router-dom";
import { useUser } from "../hooks/useUser";
import { isUserAdmin } from "../config/admin";
import { Result, Button } from "antd";

/**
 * AdminGuard - A component that protects routes that should only be accessible to admin users.
 * It checks if the user is both authenticated and has admin permissions.
 * If not, it displays a 403 error or redirects to the dashboard.
 */
export const AdminGuard: React.FC = () => {
  const { user, loading } = useUser();

  // If still loading, show nothing (or could add a loading spinner here)
  if (loading) {
    return <div>Loading...</div>;
  }

  // Check if user exists and is an admin
  const isAdmin = user ? isUserAdmin(user.id) : false;

  // If not admin, show a 403 Forbidden message
  if (!isAdmin) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={
          <Button
            type="primary"
            onClick={() => (window.location.href = "/dashboard")}
          >
            Back to Dashboard
          </Button>
        }
      />
    );
  }

  // If admin, render the protected route
  return <Outlet />;
};
